/**
 * URL de un destino externo, lista para un `href`.
 *
 * El dato que carga un artista o un admin no siempre trae esquema. Un `href` con
 * `www.ignaciosanzana.com` **no** es un enlace externo: el navegador lo resuelve
 * como ruta relativa y termina en `artstgo.cl/www.ignaciosanzana.com`. En
 * producción hay 28 artistas activos así (ABC-440).
 *
 * Devuelve `'#'` cuando no hay nada usable, para no dejar un `href=""` que
 * recarga la página.
 */
export function urlExterna(valor: string | null | undefined): string {
    const limpio = (valor ?? '').trim();
    if (!limpio) {
        return '#';
    }

    // Ya trae esquema (incluido `//host`, mailto:, tel:): se respeta tal cual.
    if (/^([a-z][a-z0-9+.-]*:|\/\/)/i.test(limpio)) {
        return limpio;
    }

    return `https://${limpio}`;
}
